import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../store/slices/authSlice';
import { authService } from '../../services/auth/auth.service';
import {
  isUserAccountActive,
  setDeactivatedRedirectMessage,
  DEACTIVATED_MESSAGE,
} from '../../utils/accountStatus';

const PrivateRoute = ({ children }) => {
  const dispatch = useDispatch();
  const { isAuthenticated, user } = useSelector((state) => state.auth);

  useEffect(() => {
    if (!isAuthenticated) return;

    if (!isUserAccountActive(user)) {
      setDeactivatedRedirectMessage(DEACTIVATED_MESSAGE);
      dispatch(logout());
      return;
    }

    let cancelled = false;
    authService
      .getMe()
      .then((response) => {
        if (cancelled) return;
        const freshUser = response?.data;
        if (!isUserAccountActive(freshUser)) {
          setDeactivatedRedirectMessage(DEACTIVATED_MESSAGE);
          dispatch(logout());
        }
      })
      .catch(() => {
        /* 401 handled globally by api interceptor */
      });

    return () => {
      cancelled = true;
    };
  }, [dispatch, isAuthenticated, user]);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!isUserAccountActive(user)) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;
